import { Input } from "@/components/ui/Input";
import { SmartToy } from "@mui/icons-material";
import { chatHistory } from "./chatData";
import { useRef, useState } from "react";

interface ChatViewProps {}

export const ChatView = ({}: ChatViewProps) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const chatMessageRef = useRef<HTMLDivElement>(null);

  return (
    <div className="flex flex-col h-[500px]">
      <div className="flex items-center gap-2 mb-4">
        <SmartToy className="w-6 h-6 text-indigo-500" />
        <h2 className="text-xl font-medium">AIQ Chat</h2>
        
      </div>
      
      {/* Chat messages area */}
      <div className="flex-1 space-y-4 mb-4 overflow-y-auto custom-scrollbar" ref={chatMessageRef}>
        {chatHistory.map((message) => (
          <div key={message.id} className={`flex gap-3 ${message.type === 'user' ? 'flex-row-reverse' : ''}`}>
            
            <div className={`flex-1 max-w-[280px]`}>
              <div className={`p-5 rounded-2xl ${
                message.type === 'user' 
                  ? 'bg-neutral-800 text-white ml-auto' 
                  : 'bg-transparent text-white/80'
              }`}>
                {message.content}
              </div>
               <div className="text-xs text-neutral-400 mt-1">{message.timestamp}</div>
             </div>
           </div>
         ))}
         <div ref={messagesEndRef} />
       </div>

      {/* Chat input */ }
      <div className="sticky bottom-0 pt-4">
        <Input
          type="text" 
          placeholder="Ask something..." 
          className="font-medium px-6 bg-neutral-100/5 text-neutral-100 py-8 w-full rounded-lg border-none [letter-spacing:0.01em]" 
        />
      </div>
    </div>
  );
};
